import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PageService} from "../../services/api/services/page/page.service";
import {TitleService} from "../../services/title.service";
import {MetaService} from "../../services/meta.service";
import {tap} from "rxjs/operators";
import {Subscription} from "rxjs";
import {Backend} from "@generated-backend-types";
import {CartHeaderService} from "../shared/components/cart-header/cart-header.service";
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {LocaleService} from "../../services/locale.service";
import Page = Backend.App.Http.Resources.Ticketshop.Content.Page;
import {CoreModule} from "../core.module";

@Component({
    selector: 'app-external-page',
    templateUrl: './external-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CoreModule]
})
export class ExternalPageComponent implements OnInit, OnDestroy {
  public page?: Page;
  public content?: SafeHtml;
  public slug: string = '';

  private activatedRouteSubscription?: Subscription;
  private translateServiceSubscription?: Subscription;


  public ngOnInit(): void {
    const path = window.location.pathname;
    this.slug = path.replace('/de/', '').replace('/en/', '')

    if (this.activatedRoute.snapshot.data['presetSlug']) {
      this.slug = this.activatedRoute.snapshot.data['presetSlug'];
    }

    if (this.slug === 'home' || this.slug === 'vehicle-consultation') {
      this.cartHeaderService.backButtonEnabled.next(false);
      this.cartHeaderService.headerEnabled.next(true);
      this.cartHeaderService.nextStepButtonEnabled.next(true);
    }

    this.loadPage(this.slug);


    this.translateServiceSubscription = this.localeService.localeChanged.pipe(
      tap(() => {
        this.insertPage(undefined);
      }))
      .subscribe({
        next: () => {
          this.loadPage(this.slug);
        }
      })


  }



  private loadPage(slug: string) {
    this.pageService.get(slug).subscribe({
      next: res => {
        this.insertPage(res.data);
      },
      error: err => {
        if (err.status === 404) {
          this.redirectToNotFound();
          return;
        }
        console.error('error during page load', err.status);
      }
    });
  }

  private insertPage(page: Page| undefined): void {

    if(page === undefined) {
      this.page = undefined;
      this.content = undefined;
      this.titleService.setTitle('');
      this.metaService.setMetaTag('description', '');
      this.cdr.markForCheck();
      return;
    }
    this.page = page;
    this.content = this.domSanitizer.bypassSecurityTrustHtml(page.localized_content);
    this.titleService.setTitle(page.localized_title);
    this.metaService.setMetaTag('description', page.localized_meta_description);
    this.cdr.markForCheck();
  }

  public ngOnDestroy() {
    this.activatedRouteSubscription?.unsubscribe();
    this.translateServiceSubscription?.unsubscribe();
  }

  public redirectToNotFound() {
    this.router.navigateByUrl(this.localeService.localizedPath('/404'));
  }

  public constructor(
    private router: Router,
    private domSanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private pageService: PageService,
    private titleService: TitleService,
    private metaService: MetaService,
    private localeService: LocaleService,
    private cartHeaderService: CartHeaderService
  ) {
  }
}
